'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInstantsearchCore = require('react-instantsearch-core');

var _utils = require('../core/utils');

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = (0, _utils.createClassNames)('Breadcrumb');

var itemsPropType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  label: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired
}));

var Breadcrumb = function (_Component) {
  _inherits(Breadcrumb, _Component);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).apply(this, arguments));
  }

  _createClass(Breadcrumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          canRefine = _props.canRefine,
          createURL = _props.createURL,
          items = _props.items,
          refine = _props.refine,
          rootURL = _props.rootURL,
          separator = _props.separator,
          translate = _props.translate,
          className = _props.className;

      var rootPath = canRefine ? _react2.default.createElement(
        'li',
        { className: cx('item') },
        _react2.default.createElement(
          _Link2.default,
          {
            className: cx('link'),
            onClick: function onClick() {
              return !rootURL ? refine() : null;
            },
            href: rootURL ? rootURL : createURL()
          },
          translate('rootLabel')
        )
      ) : null;

      var breadcrumb = items.map(function (item, idx) {
        var isLast = idx === items.length - 1;
        return _react2.default.createElement(
          'li',
          { className: cx('item', isLast && 'item--selected'), key: idx },
          _react2.default.createElement(
            'span',
            { className: cx('separator') },
            separator
          ),
          !isLast ? _react2.default.createElement(
            _Link2.default,
            {
              className: cx('link'),
              onClick: function onClick() {
                return refine(item.value);
              },
              href: createURL(item.value)
            },
            item.label
          ) : item.label
        );
      });

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(cx('', !canRefine && '-noRefinement'), className)
        },
        _react2.default.createElement(
          'ul',
          { className: cx('list') },
          rootPath,
          breadcrumb
        )
      );
    }
  }]);

  return Breadcrumb;
}(_react.Component);

Breadcrumb.propTypes = {
  canRefine: _propTypes2.default.bool.isRequired,
  createURL: _propTypes2.default.func.isRequired,
  items: itemsPropType,
  refine: _propTypes2.default.func.isRequired,
  rootURL: _propTypes2.default.string,
  separator: _propTypes2.default.node,
  translate: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string
};
Breadcrumb.defaultProps = {
  rootURL: null,
  separator: ' > ',
  className: ''
};
exports.default = (0, _reactInstantsearchCore.translatable)({
  rootLabel: 'Home'
})(Breadcrumb);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/Breadcrumb.js
// module id = 979
// module chunks = 142807904292071